import React from 'react';
import PropTypes from 'prop-types';
import MetaField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import InputGroup from 'Components/ComponentLibrary/Molecules/InputGroup';
import getFieldsWithGroups from './getFieldListWithGroups';

const Field = ({ field }) => (<MetaField
  notInLayout
  key={field.id()}
  attr={field.attr('name')}
/>);
Field.propTypes = {
  field: PropTypes.object.isRequired,
};

/**
 * MetaLayoutFields returns the meta fields without any wrapper component.
 * This allows the consumer of this component to decide the layout of the fields.
 *
 * @deprecated use MetaLayoutRemainingFields
 * @param resource {Resource}
 * @return {JSX.Element}
 */
export default function MetaLayoutFields({
  resource,
}) {
  const {
    remainingFields,
  } = useMetaLayoutContext();

  const fieldsWithGroups = getFieldsWithGroups(resource, remainingFields);

  return (
    <>
      {fieldsWithGroups
        .map((field) => {
          if (Array.isArray(field)) {
            return (
              <InputGroup>
                {field.map(f => (<Field field={f} />))}
              </InputGroup>
            );
          }

          return (<Field field={field} />);
        })}
    </>
  );
}
MetaLayoutFields.propTypes = {
  resource: PropTypes.object.isRequired,
};
